import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import SiteInfo from '../../../../../models/SiteInfo';
import './SideInfoDetail.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class SiteInfoDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            siteinfo: this.props.siteInfoState.detail.siteinfo,
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getSiteInfoDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setSiteInfoDetail(new SiteInfo())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.siteInfoState.detail.siteinfo && !isEqual(nextProps.siteInfoState.detail.siteinfo, this.props.siteInfoState.detail.siteinfo)) {
            this.setState({ siteinfo: nextProps.siteInfoState.detail.siteinfo, action: nextProps.siteInfoState.detail.siteinfo.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t } =  this.props;
        const { action, isSubmit, validation, isGetItem, siteinfo } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="siteinfo-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'siteinfos'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.siteinfo.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.siteinfo.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={siteinfo.translations}
                                    current={siteinfo.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange('languageCode', language.code)}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    <Wrapper className="col-md-3" />
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={siteinfo.name}
                                            validation={validation.name}
                                            labelTitle={t(`item.siteinfo.name`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                value={Func.checkUndefine(siteinfo.name)} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={siteinfo.key}
                                            validation={validation.key}
                                            labelTitle={t(`item.siteinfo.key`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('key', e.target.value)}
                                                value={checkUndefine(siteinfo.key)} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={siteinfo.value}
                                            validation={validation.value}
                                            labelTitle={t(`item.siteinfo.value`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('value', e.target.value)}
                                                value={checkUndefine(siteinfo.value)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-3" />
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onSaveTranslate = () => {
        const { siteinfo } = this.state;
        const translateFunction = siteinfo.translate.id ? this.props.updateSiteInfoTranslate : this.props.createSiteInfoTranslate;
        translateFunction(siteinfo, siteinfo.languageCode);
        this.onExitTranslate();
    }

    onChange = (fieldName, value) => {
        const siteinfo = this.state.siteinfo;
        const keyString = fieldName === 'key' ? this.convertStringKey(value) : value;
        siteinfo[fieldName] = keyString.trimLeft();
        this.setState({ siteinfo });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { siteinfo, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createSiteInfoDetail(siteinfo)
            } else {
                this.props.updateSiteInfoDetail({ siteinfo, props: this.props })
            }
        }
    }

    convertStringKey = (value) => {
        const convertedString = Func.vietnameseStringToUnicode(value)
        return convertedString.replace(" ", "_", convertedString.replace("&*#39;","",convertedString));
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.siteinfo.name`)),
                key: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.siteinfo.key`)),
                value: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.siteinfo.value`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.siteinfo, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.SITEINFO.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { siteinfo } = this.state;
        siteinfo.setTranslate(language.code);
        siteinfo.setData();
        this.setState({ siteinfo, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const siteinfo = cloneDeep(this.state.siteinfo);
        const action = DETAIL_ACTIONS[siteinfo.id ? 'UPDATE' : 'CREATE'];
        siteinfo.setTranslate(undefined, true);
        siteinfo.setData();
        this.setState({ siteinfo, action });
    }

    onSaveTranslate = () => {
        const { siteinfo } = this.state;
        const translateFunction = siteinfo.translate.id ? this.props.updateSiteInfoTranslate : this.props.createSiteInfoTranslate;
        translateFunction(siteinfo, siteinfo.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { siteinfo } = this.state;
        siteinfo.setTranslate(language.code);
        this.props.deleteSiteInfoTranslate(siteinfo, { id: siteinfo.id });
    }
}

export default SiteInfoDetail;
